<template>
<div class ="contenedor-tabla">
  <div style="overflow-x: auto; overflow-y: hidden; border-radius: 10px;">
      <table>
          <!-- <caption class="table-header">{{ this.$t('tabs.gas_parametros') }} Gas</caption> -->
          <thead>
            <tr>
              <th class="encabezado" >{{ this.$t('gas.campo') }}</th>
              <th class="encabezado" >{{ this.$t('gas.valor') }}</th>
            </tr>
          </thead> 
          <tbody>
            <tr v-for="(valor, clave) in parametros" :key="clave" class="tabla-hover">
              <template v-if="clave!='usar_input'">

             
                <td class="primera_columna">{{ this.$t('gas.'+clave)}}</td>
                <td>
                  <input
                    type="number"
                    v-model.number="parametros[clave]"
                    @input="emitChanges"
                    step="0.1"
                  />
                </td>
                <td v-if="clave=='input_prov'">
                  <v-switch
                    v-model="parametros['usar_input']"
                    :true-value="1"
                    :false-value="0"
                    @change="emitChanges"
                    color="#0076A0"
                    :label="$t('gas.label_switch_input')"
                    hide-details
                  ></v-switch>

                </td>
              </template>
            </tr>
          </tbody>
        </table>
  </div>
</div>
</template>

<script>
export default {
    props:{
        gas_parametros:{
            type:Object,
            required:true,
        },
    },
    data(){
            return {
                parametros:{...this.gas_parametros},

            }
    },
    methods:{
        emitChanges(){
        this.$emit("update:gas_parametros", this.parametros);
      },
      /*Formatea los números a dos decimales 
        formatDecimal(value) {
          return value ? Number(value).toFixed(2) : "0.00";
        },

        // Actualiza el valor 
        updateParametro(clave, value) {
          const newValue = parseFloat(value).toFixed(2); // Redondea a dos decimales

          this.parametros = {
            ...this.parametros,
            [clave]: Number(newValue),
          };

          this.emitChanges();
        },*/
    },
    watch:{

    },
}
</script>

<style scoped>
.contenedor-tabla {
  max-width: 600px;
  /* margin: auto; */
}
table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
  .table-header {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
  }
  

  .primera_columna{
    background-color: white;
  }
  .valor_fijo{
    background-color: white;
  }

  input[type="number"] {
    width: 100%;
    text-align: center;
    border: none;
    border-radius: 4px;
    color: #024e74;
  }
  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  
  input[disabled] {
    background-color: white;
    color: #024e74;
    cursor: not-allowed;
  }

</style>